import React, { useState } from 'react';
import { Link, NavLink } from "react-router-dom";
import { HiPlus, HiMinus } from 'react-icons/hi';

import CartFooter from "../../common/CartFooter";
import BookingCalendar2 from '../BookingCalendar2';
import { Button } from 'react-bootstrap';

function RescheduleAppointment() {

    const [isOpened, setIsOpened] = useState(false);
    function toggle() {
        setIsOpened(wasOpened => !wasOpened);
    }

    return(
        <>
        
        {!isOpened && ( 

<>

<div className="container">
<div className="cart-wrap small">
   <div className="cart-list">
       <h2 className="title left">reschedule appointment</h2>
       <div className="cart-list-group">
           <h3>treatments</h3>
           <div className="table-div">
           <div className="table-row thead">
               <div className="table-col head">Name</div>
               <div className="table-col head">Quantity</div>
               <div className="table-col head">Appointment</div>
               <div className="table-col head"></div>
           </div>
           <div className="table-row">
               <div className="table-col">
                   <div className="productName">
                       <div className="productImage"><img alt="" src={require('../../images/product/lip-filter.png')} /></div>
                       <span>Lip filler</span>
                   </div>
               </div>
               <div className="table-col">
                   <div className="qty-box">
                       <div className="qty-icon"><HiMinus/></div>
                       <div className="qty-input">
                           <input value="0.5 ml" type="text" />
                       </div>
                       <div className="qty-icon"><HiPlus/></div>
                   </div>
               </div>
               <div className="table-col"><Button className="themeBtn line">update</Button></div>
               <div className="table-col itemClose"><img alt="" src={require('../../images/icons/close-single.png')} /></div>
           </div>
           
           <div className="table-row-extend">
               <p>Appointment date & time: <span>01 October 2022, 12:30 PM.</span></p>
               <p>Clinic address: <span>Bank Station (London underground)</span></p>
           </div>

           <div className="table-row">
               <div className="table-col">
                   <div className="productName">
                       <div className="productImage"><img alt="" src={require('../../images/product/bum.jpg')} /></div>
                       <span>Brazilian bum lift consultation</span>
                   </div>
               </div>
               <div className="table-col">
                   <span>1</span>
               </div>
               <div className="table-col"><Button className="themeBtn line">update</Button></div>
               <div className="table-col itemClose"><img alt="" src={require('../../images/icons/close-single.png')} /></div>
           </div>

           <div className="table-row-extend">
               <p>Appointment date & time: <span>01 October 2022, 12:30 PM.</span></p>
               <p>Clinic address: <span>Bank Station (London underground)</span></p>
           </div>

           </div>
       </div>
   </div>
</div>
</div>

<div className="cart-footer">
 <div className="container">
     <div className="priceButton pt-4 justify-content-center">
       <button className="themeBtn line red btnFull-mob" onClick={toggle}>Cancel Appointment</button>
     </div>
 </div>

 <CartFooter/>

</div>
        </>
        )}
          

          {isOpened && <BookingCalendar2/>}

        </>
    )
}

export default RescheduleAppointment;